// @flow
import t from "common/i18n";
import createBoundActionCreators, {
	createCustomCreator,
	createDispatcher,
} from "common/actionsBase";
import rootBindActions, { types as rootTypes } from "root/actions";
import { fileSelect } from "tabs/common/actionMethods";
import getGoogle from "../service";
import {
	selectSearchTerm,
	selectIsIdSelected,
	selectReachedMaxSelection,
	selectMultipleIdsInRange,
	selectAvailableUntilMax,
} from "../selectors";

export const types = {
	DO_IMAGE_SEARCH: "IS_DO_IMAGE_SEARCH",
	SET_SEARCH_TERM: "IS_SET_SEARCH_TERM",
	SET_IMAGE_SEARCH_START: "IS_SET_IMAGE_SEARCH_START",
	SET_IMAGE_SEARCH_SUCCESS: "IS_SET_IMAGE_SEARCH_SUCCESS",
	SET_IMAGE_SEARCH_FAIL: "IS_SET_IMAGE_SEARCH_FAIL",
	SET_FILE_SELECTION: "IS_SET_FILE_SELECTION",
	SET_MULTI_FILE_SELECTION: "IS_SET_MULTI_FILE_SELECTION",
	CLEAR_IMAGE_SELECTION: "IS_CLEAR_IMAGE_SELECTION",
	SET_SEARCH_RIGHT: "SET_SEARCH_RIGHT",
	SET_SEARCH_SITE: "SET_SEARCH_SITE",
	CLEAR_SEARCH_ERROR: "CLEAR_SEARCH_ERROR",
	RESET_SEARCH: "RESET_SEARCH",
	SET_OPTIONS_VISIBILITY: "SET_OPTIONS_VISIBILITY",
};

type SearchParams = {
    query: ?string,
    apiKey: string,
    start?: number,
    searchSite?: string,
    searchRight?: string,
    images?: Object[],
    reportError: Function
};

export default createBoundActionCreators(types, {

	[types.CLEAR_IMAGE_SELECTION]: createCustomCreator((dispatch: Function) => {
		createDispatcher(dispatch)([
			[types.CLEAR_IMAGE_SELECTION],
			[rootTypes.CLEAR_MAX_SELECT_REACHED]]);
	}),

	[types.SET_FILE_SELECTION]: createCustomCreator(
		({ id, e, multiple }, dispatch: Function, getState: Function) => fileSelect({
			id,
			e,
			types: { ...rootTypes, ...types },
			rootBindActions,
			selectIsIdSelected,
			selectReachedMaxSelection,
			selectMultipleIdsInRange,
			selectAvailableUntilMax,
			multiple,
		}, dispatch, getState),
	),

	[types.DO_IMAGE_SEARCH]: createCustomCreator(
		async (searchParams: SearchParams, dispatch: Function, getState: Function) => {
			const dispatcher = createDispatcher(dispatch);
			const searchTerm = searchParams.query || selectSearchTerm(getState()).searchTerm;

			dispatcher(types.SET_IMAGE_SEARCH_START);

			const google = getGoogle({ apiKey: searchParams.apiKey });
			const result = await google.doSearch({
				query: searchTerm,
				start: searchParams.start,
				searchSite: searchParams.searchSite,
				searchRight: searchParams.searchRight,
				images: searchParams.images,
			});

			if (result.error) {
				dispatcher(types.SET_IMAGE_SEARCH_FAIL, { error: result.error });
				searchParams.reportError({ text: t("image_search.search_error") });
			} else {
				dispatcher(types.SET_IMAGE_SEARCH_SUCCESS, {
					images: result.images,
					queries: result.queries,
				});
			}
		},
	),
});
